import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

/**
 * Custom Warning Modal for Unanswered Questions
 *
 * Replaces browser default alert with a beautiful custom modal
 */
const UnansweredWarningModal = ({ unansweredCount, onContinue, onCancel }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 animate-in zoom-in-95 duration-200">
        {/* Header */}
        <div className="relative bg-gradient-to-br from-emerald-50 to-teal-50 px-6 py-5 rounded-t-2xl border-b border-emerald-100">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg">
              <AlertTriangle className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-slate-900">Unanswered Questions</h3>
            </div>
          </div>

          {/* Close button */}
          <button
            onClick={onCancel}
            className="absolute top-4 right-4 p-1.5 hover:bg-emerald-100 rounded-lg transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-slate-600" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="text-slate-700 leading-relaxed mb-4">
            Are you sure you want to submit? Unanswered questions will be marked as incorrect.
          </p>

          {/* Info box */}
          <div className="bg-emerald-50 border-2 border-emerald-200 rounded-xl p-4 mb-4">
            <div className="flex gap-3">
              <div className="w-8 h-8 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
                <span className="text-lg font-black text-emerald-600">{unansweredCount}</span>
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-emerald-900">
                  {unansweredCount === 1
                    ? '1 question left unanswered'
                    : `${unansweredCount} questions left unanswered`}
                </p>
                <p className="text-xs text-emerald-700 mt-1">
                  Review your quiz before submitting to maximize your score.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 bg-slate-50 rounded-b-2xl flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-5 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-semibold shadow-lg transition-all active:scale-[0.98]"
          >
            Review
          </button>
          <button
            onClick={onContinue}
            className="flex-1 px-5 py-3 bg-white border border-slate-200 hover:bg-slate-50 text-slate-600 rounded-xl font-medium transition-all active:scale-[0.98]"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnansweredWarningModal;
